import { PropsWithChildren } from 'react';

import { Logo } from '@client/toolkit';

import { OnboardingStepper } from './onboarding-stepper';

interface OnboardingLayoutProps {
  currentStep: number;
}

export function OnboardingLayout({ currentStep, children }: PropsWithChildren<OnboardingLayoutProps>) {
  return (
    <div className="h-screen bg-background flex flex-col overflow-y-auto">
      <div className="flex justify-center pt-8 pb-4">
        <Logo className="w-16 h-16" />
      </div>

      <div className="px-4 py-4">
        <OnboardingStepper currentStep={currentStep} />
      </div>

      <div className="flex-1 flex flex-col items-center px-4 pb-12">
        <div className="w-full max-w-2xl">
          {children}
        </div>
      </div>
    </div>
  );
}
